import React from 'react';
import { Row, Col } from 'react-bootstrap';
import renderUtils from '../../../helpers/renderUtils';

const ResultHeader = ({
                        heading = 'Dostępne domki',
                        subHeading,
                        className = '',
                        offersResult,
                      }) => {
  if (!offersResult) return <></>;


  const { searchParams, result } = offersResult;
  const { startDate, endDate, adults, children, infants } = searchParams;


  const totalGuests = (Number(adults) || 0) + (Number(children) || 0) + (Number(infants) || 0);

  return (
    <Row className={`mb-4 ${className}`}>
      <Col md={4}></Col>
      <Col md={8}>
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h2 className="h2 fw-semibold m-0">{heading}</h2>

          {!subHeading && (
            <div className="text-muted small text-end">
              <span>{result?.length} wyników</span>
              {startDate && endDate && (
                <>
                  <span className="mx-2">·</span>
                  <span>
                    {renderUtils.formatDate(startDate)} - {renderUtils.formatDate(endDate)}
                  </span>
                </>
              )}
              {(adults || children || infants) > 0 && (
                <>
                  <span className="mx-2">·</span>
                  <span>
                    {totalGuests} {renderUtils.getGuestLabel(totalGuests)}
                  </span>
                </>
              )}
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default ResultHeader;
